import Icon from '@material-ui/icons/Theaters';

import List from './List';

export default {
  name: 'reports/series',
  icon: Icon,
  list: List,
};
